export class BluetoothTimeoutError extends Error {
    // BluetoothTimeoutError type
}
